import { ChangeDetectionStrategy, Component } from '@angular/core';

import { ViewBaseComponent } from '../view-base/view-base.component';

@Component({
  selector: 'view-data-list',
  templateUrl: './view-data-list.component.html',
  styleUrls: ['./view-data-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewDataListComponent extends ViewBaseComponent {}
